import ConstructorIO from '@constructor-io/constructorio-client-javascript';
import { ConstructorClientOptions } from '@constructor-io/constructorio-client-javascript/lib/types';
import { buildUserSegments } from './user-segments';
import { HomeDetailsResponse } from 'common/api/crm/home/models/HomeDetailsResponse';
import { CONSTRUCTOR_KEY } from 'common/env';

const constructorApiKey = CONSTRUCTOR_KEY || 'none';

function createBaseConstructorInstance() {
    try {
        return new ConstructorIO({
            apiKey: constructorApiKey,
        } as unknown as ConstructorClientOptions);
    } catch (error) {
        return new ConstructorIO({
            apiKey: constructorApiKey,
            sessionId: 1 as unknown as string,
            clientId: '0',
        } as unknown as ConstructorClientOptions);
    }
}

const baseConstructorInstance = createBaseConstructorInstance();

export function updateConstructorSegments(homeDetails: HomeDetailsResponse | null): string[] {
    const userSegments = buildUserSegments(homeDetails);
    // Set segments directly on the client options
    (baseConstructorInstance as any).options.segments = userSegments;
    return userSegments;
}

export const constructorInstance = baseConstructorInstance;
